import script from "./MultiPositionPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiPositionPanel.vue?vue&type=script&lang=ts&setup=true"

import "./MultiPositionPanel.vue?vue&type=style&index=0&id=c88d31ba&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c88d31ba"]])

export default __exports__